import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import Chess from "./chess/chess";
import Chat from "./chat/chatRoom";
import Video from "./video/VideoRoom";
import VideoEmpty from "./video/VideoRoomEmpty";

import "./board.css";

const Board = () => {
	const dispatch = useDispatch();
	const history = useHistory();

	const userState = useSelector(state => state.user);
	const role = userState.role;

	return (
		<div className="combination-page">
			<div className="right">
				<div className="right-container">
					<div className="video">{role === "white" || role === "black" ? <Video /> : <VideoEmpty />}</div>
					<div className="chat"> {<Chat />}</div>
				</div>
			</div>

			<div className="left">
				<div className="chess">
					<Chess />
				</div>
			</div>
		</div>
	);
};

export default Board;
